<template>
  <ProgressSpinnerContainer label="Logging out..."></ProgressSpinnerContainer>
</template>

<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
import { selectedAccount } from "../../store/state.js";
import ProgressSpinnerContainer from "../ProgressSpinnerContainer.vue";

const { logout } = useAuth0();

selectedAccount.value = null

logout({ logoutParams: { returnTo: window.location.origin } })
</script>